(function () {
    var directivesModule = angular.module('customeDirectivesModule');

    directivesModule.directive('npFreezeTabContent', ['$timeout', 'tabStateService', function ($timeout, tabStateService) {
        return {
            restrict: 'A',
            replace: true,
            scope: {
                tabId: '@id',
                stateType: '@',
                toggleSidebar: '='
            },
            link: function (scope, element, attrs) {
                var identifierSelector = '#' + scope.tabId + '';
                angular.element(identifierSelector).click(function (e) {
                    $timeout(function () {
                        tabStateService.adjustContentPosition(scope.tabId, scope.stateType);
                    }, 0, false);
                });

                scope.$watch('toggleSidebar', function (toggleSidebar) {
                    // Extra processing for 'Updated Favorite' tab
                    if (scope.tabId == homeTabs.updatedFavorite) {
                        var updateFavoritePrintbox = angular.element('#' + homeContent.updatedFavoritePage + ' #print-box2');
                        if (toggleSidebar == true) {
                            updateFavoritePrintbox.removeClass(avoidCustomPageClass);
                        } else {
                            updateFavoritePrintbox.addClass(avoidCustomPageClass);
                        }
                    } else if (scope.tabId == homeTabs.whatNew) {
                        angular.element('#' + homeContent.whatNew + ' #print-box2').addClass(avoidCustomPageClass);
                    }
                });
            }
        };
    }]);

    directivesModule.directive('emHeightSource', ['localStorageService', 'tabStateService', function (localStorageService, tabStateService) {

        return {
            controller: ['$scope', 'tabStateService', '$timeout', controller],
            replace: true,
            scope: {
                tabActive: '@',
                stateType: '@'
            },
            link: function (scope, elem, attrs) {
                scope.$watch(function () {
                    var tabActive = null;
                    switch (scope.stateType) {
                        case tabStateType.documentTabState:
                            tabActive = localStorageService.getItem('DocumentTabState');
                            //if (!tabActive) {
                            //    tabStateService.setState(tabStateType.documentTabState, documentTabs.content);
                            //    tabActive = documentTabs.content;
                            //}
                            break;
                        case tabStateType.chapterTabState:
                            tabActive = localStorageService.getItem('ChapterTabState');
                            //if (!tabActive) {
                            //    tabStateService.setState(tabStateType.chapterTabState, folderTabs.content);
                            //    tabActive = folderTabs.content;
                            //}
                            break;

                    }
                    if (tabActive && scope.tabActive == tabActive) {
                        scope.__height = elem.height();
                    }
                    else {
                        if (!tabActive) {
                            scope.__height = 0;
                        }
                    }

                });
            }
        }

    }]);

    function controller($scope, tabStateService, $timeout) {
        $scope.$watch('__height', function (newHeight, oldHeight) {
            if (newHeight && Number(newHeight) > 0) {            
                $timeout(function () {
                    tabStateService.adjustContentHeightPosition($scope.stateType, newHeight);
                }, 0);
            }
        });
    }

})();